import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * RoleGuard - Restricts route access to specific roles.
 * If the user's role is not in the allowedRoles list,
 * they are redirected to their default dashboard.
 *
 * Usage:
 *   <RoleGuard allowedRoles={['admin', 'coordinator']}>
 *     <AdminPage />
 *   </RoleGuard>
 */
export default function RoleGuard({ allowedRoles, children }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  // Determine effective role (housing residents may have role='client' with flag)
  const effectiveRole = user.is_housing_resident ? 'housing_resident' : user.role;

  if (!allowedRoles.includes(effectiveRole)) {
    const homeRoutes = {
      housing_resident: '/my-progress',
      housing_coordinator: '/our-square',
      housing_staff: '/our-square',
      referral_source: '/agency-view',
      court_officer: '/agency-view',
    };
    const home = homeRoutes[effectiveRole] || '/dashboard';
    return <Navigate to={home} replace />;
  }

  return children;
}
